import React, { useEffect, useState } from "react";
import fire from "../../firebase";

const Settings = () => {
  const [data, setData] = useState({
    certificate: "",
    meet: "",
  });
  useEffect(() => {
    fire
      .firestore()
      .collection("settings")
      .doc("users")
      .get()
      .then((doc) => {
        if (doc.exists) {
          setData(doc.data());
        }
      });
  }, []);
  const handleChange = (e) => {
    var { name, value } = e.target;
    setData({
      ...data,
      [name]: value,
    });
  };
  const saveChanges = (e) => {
    e.preventDefault();
    fire.firestore().collection("settings").doc("users").set(data);
  };
  return (
    <div className="admin">
      <h1 style={{ textAlign: "center" }}>Settings</h1>
      <form onSubmit={saveChanges} className="sett">
        <div className="sett-1">
        <label htmlFor="certi">Show Certificate</label>
        <select
          id="certi"
          name="certificate"
          value={data.certificate}
          onChange={handleChange}
        >
          <option value="show">Show</option>
          <option value="notshow">Not Show</option>
        </select>
        </div>
        <br />
        <div className="sett-2">
        <label htmlFor="meetURL">Google Meet URL</label>
        <input
          onChange={handleChange}
          type="url"
          id="meetURL"
          name="meet"
          value={data.meet}
        />
        </div><br/><br/>  
        <button style={{marginLeft: "25%", marginRight: "25%"}} className="sett-sub" type="submit">Save Changes</button>
      </form>
    </div>
  );
};

export default Settings;
